import { logger } from '../../logger';
import {
    ICarrierStoreEventHandler,
    ParcelConfirmedParameters,
    ParcelScannedParameters, ParcelScannedResult,
    ParcelStoreCancelledParameters
} from './ICarrierStoreEventHandler';
import {DhlRestClient, KepServiceError} from "../../rest-clients/DhlRestClient";

const log = logger.sub("DhlCarrierStoreEventHandler");

export class DhlCarrierStoreEventHandler implements ICarrierStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<ParcelScannedResult|undefined> {
        log.info(`Called dhl carrier store parcel scanned event handler for ${params.parcelId}`);
        const { baseUrl, token } = params.backendApiCredentials;
        const restClient = new DhlRestClient(baseUrl, token);
        const response = await restClient.sendShipmentQuery(params.parcelId, params.cubeId);

        if (!response.ok || !response.body.success) {
            const err = new KepServiceError(JSON.stringify(response));
            err.body = response.body;
            throw err;
        }

        return {
            size: response.body.size,
            errorCode: response.body.errorCode,
            shipmentId: response.body.shipmentId,
        }
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        throw new Error("Dhl carrier store parcel store cancelled event not implemented");
    }

    async parcelStoreConfirmed(params: ParcelConfirmedParameters): Promise<void> {
        throw new Error("Dhl carrier store parcel store confirmed event not implemented");
    }
}